export default {
  today: 'Сегодня',
  yesterday: 'Вчера',
  'ticket.list.status_pending': 'Новый',
  'ticket.list.status_working': 'В работе',
  'ticket.list.status_closed': 'Закрыт',
  'ticket.list.status_unknown': 'Неизвестно',
  'ticket.list.id': '#%1 от %2',
  'deposit.min_msg': 'Минимальная сумма для пополнения %1 %2',
  'legal_entity.status_new': 'В обработке',
  'legal_entity.status_approved': 'Подтверждено',
  'legal_entity.status_declined': 'Отклонено',
  'legal_entity.invoice.status_new': 'В обработке',
  'legal_entity.invoice.paid': 'Оплачено',
  'access.role_managers.title': 'Администраторы',
  'access.role_reporters.title': 'Наблюдатели',
  'partner_payment.status_pending': 'В процессе',
  'partner_payment.status_paused': 'Пауза',
  'partner_payment.status_error': 'Ошибка',
  'partner_payment.status_success': 'Обработан',
  'partner_payment.status_cancelled': 'Отменен',
  'partner_payment.status_declined': 'Отклонен',
  'billing_profile.payment.method.epayments': 'Epayments',
  'billing_profile.payment.method.juridical': 'Юридическое лицо',
  'billing_profile.payment.method.qiwi': 'QIWI',
  'billing_profile.payment.method.paymaster': 'WebMoney',
  'billing_profile.payment.method.paymaster_ru': 'WebMoney WMP',
  'billing_profile.payment.method.paypal': 'PayPal',
  'billing_profile.payment.method.lucky': 'Lucky.online',
  'billing_profile.payment.method.stripe': 'Банковская карта',
  'billing_profile.payment.method.winpay': 'WinPay',
  'billing_profile.payment.method.tinkoff': 'Тинькофф',
  'billing_profile.payment.method.paymaster_service': 'Paymaster',
  'billing_profile.withdrawal.method.bank_card': 'Банковская карта',
  'billing_profile.withdrawal.method.webmoney': 'WebMoney',
  'billing_profile.withdrawal.method.epayments': 'Epayments',
  'billing_profile.status_new': 'На модерации',
  'billing_profile.status_pending': 'На модерации',
  'billing_profile.status_approved': 'Подтверждено',
  'billing_profile.status_declined': 'Отклонено',
  'payment_profile.epayments.tax_number_label': 'Налоговый номер',
  'payment_profile.epayments.ru_tax_number_label': 'ИНН',
  'payment_profile.paymaster.tax_number_label': 'Налоговый номер',
  'payment_profile.paymaster.ru_tax_number_label': 'ИНН',
  'payment_profile.qiwi.tax_number_label': 'Налоговый номер',
  'payment_profile.qiwi.ru_tax_number_label': 'ИНН',
  'payment_profile.paypal.tax_number_label': 'Налоговый номер',
  'payment_profile.paypal.ru_tax_number_label': 'ИНН',
  'payment_profile.ru_tax_number_label': 'ИНН',
  'payment_profile.tax_number_label': 'Налоговый номер',
  'invoice.status.new': 'Новый',
  'invoice.status.pending': 'В работе',
  'invoice.status.waiting': 'Ожидает оплаты',
  'invoice.status.paid': 'Оплачен',
  'invoice.title': '%1 от %2',
  'invoice.title_new': 'Новый счет',
  'invoice.title_id': 'Счет №%1',
  'payment_profile.juridical.contact_person_label': 'Contact Person',
  'payment_profile.juridical.phone_label': 'Phone No.',
  'payment_profile.juridical.email_label': 'Email address',
  'payment_profile.juridical.currency_label': 'Invoice currency',
  'payment_profile.juridical.tax_number_local_label': 'ИНН',
  'payment_profile.juridical.tax_number_foreign_label': 'VAT number',
  'payment_profile.juridical.juridical_address_local_label': 'Юридический адрес',
  'payment_profile.juridical.juridical_address_foreign_label': 'Registered Address',
  'payment_profile.juridical.actual_address_local_label': 'Фактический адрес',
  'payment_profile.juridical.actual_address_foreign_label': 'Communication Address',
  'credit.title': 'Обещанный платеж #%1',
  'credit.status_pending': 'В ожидании',
  'credit.status_approved': 'Одобрен',
  'credit.status_declined': 'Отклонен',
  'credit.status_repaid': 'Оплачен',
  'yandex_subscription.campaign.budget': '%1 %2',
  'yandex_subscription.campaign.prediction': 'Примерно %1 потенциальных клиентов в месяц',
  'yandex_subscription.campaign.benefit': 'выгоднее на',
  'yandex_subscription.campaign.budgetType_WEB_MINIMAL': 'Минимальный',
  'yandex_subscription.campaign.budgetType_WEB_MAXIMAL': 'Максимальный',
  'yandex_subscription.campaign.budgetType_WEB_OPTIMAL': 'Оптимальный',
  'yandex_subscription.campaign.budgetType_MINIMAL': 'Минимальный',
  'yandex_subscription.campaign.budgetType_MAXIMAL': 'Максимальный',
  'yandex_subscription.campaign.budgetType_OPTIMAL': 'Оптимальный',
  'yandex_subscription.campaign.budgetType_DEFAULT': 'По умолчанию',
  'yandex_subscription.campaign.duration': '%1 дней (%2)',
  'yandex_subscription.promocode.apply.success': 'Прокод успешно применён',
  'yandex_subscription.need_replenish': 'Недостаточно средств для запуска кампании. <a href="%1" target="_blank">Пополнить аккаунт</a>',
  'yandex_subscription.slow_processing': 'Кампания создается дольше обычного, она добавится в список кампаний в течение нескольких минут',
  'financial_transaction.yandexsubscription.account_error': "Ошибка при создании аккаунта",
  'financial_transaction.yandexsubscription.campaign_error': "Не удалось создать рекламную кампанию",
  'financial_transaction.yandexsubscription.deposit_error': "Не удалось пополнить баланс аккаунта",
}
